'use strict';

var _regeneratorRuntime = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var normaliseInputMultiple_browser = require('./files/normalise-input-multiple.browser.js');

var modeToString = require('./mode-to-string.js');

function multipartRequest(_x, _x2) {
  return _multipartRequest.apply(this, arguments);
}

function _multipartRequest() {
  _multipartRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, abortController) {
    var headers,
        parts,
        formData,
        index,
        total,
        _iteratorAbruptCompletion,
        _didIteratorError,
        _iteratorError,
        _iterator,
        _step,
        _step$value,
        content,
        path,
        mode,
        mtime,
        fileSuffix,
        type,
        fieldName,
        qs,
        secs,
        nsecs,
        end,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            parts = [];
            formData = new FormData();
            index = 0;
            total = 0;
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 7;
            _iterator = _asyncIterator(normaliseInputMultiple_browser.normaliseInput(source));

          case 9:
            _context.next = 11;
            return _iterator.next();

          case 11:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 37;
              break;
            }

            _step$value = _step.value, content = _step$value.content, path = _step$value.path, mode = _step$value.mode, mtime = _step$value.mtime;
            fileSuffix = '';
            type = content ? 'file' : 'dir';

            if (index > 0) {
              fileSuffix = "-".concat(index);
            }

            fieldName = type + fileSuffix;
            qs = [];

            if (mode !== null && mode !== undefined) {
              qs.push("mode=".concat(modeToString.modeToString(mode)));
            }

            if (mtime != null) {
              secs = mtime.secs, nsecs = mtime.nsecs;
              qs.push("mtime=".concat(secs));

              if (nsecs != null) {
                qs.push("mtime-nsecs=".concat(nsecs));
              }
            }

            if (qs.length) {
              fieldName = "".concat(fieldName, "?").concat(qs.join('&'));
            }

            if (!content) {
              _context.next = 28;
              break;
            }

            formData.set(fieldName, content, path != null ? encodeURIComponent(path) : undefined);
            end = total + content.size;
            parts.push({
              name: path,
              start: total,
              end: end
            });
            total = end;
            _context.next = 33;
            break;

          case 28:
            if (!(path != null)) {
              _context.next = 32;
              break;
            }

            formData.set(fieldName, new File([''], encodeURIComponent(path), {
              type: 'application/x-directory'
            }));
            _context.next = 33;
            break;

          case 32:
            throw new Error('path or content or both must be set');

          case 33:
            index++;

          case 34:
            _iteratorAbruptCompletion = false;
            _context.next = 9;
            break;

          case 37:
            _context.next = 43;
            break;

          case 39:
            _context.prev = 39;
            _context.t0 = _context["catch"](7);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 43:
            _context.prev = 43;
            _context.prev = 44;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 48;
              break;
            }

            _context.next = 48;
            return _iterator.return();

          case 48:
            _context.prev = 48;

            if (!_didIteratorError) {
              _context.next = 51;
              break;
            }

            throw _iteratorError;

          case 51:
            return _context.finish(48);

          case 52:
            return _context.finish(43);

          case 53:
            return _context.abrupt("return", {
              total: total,
              parts: parts,
              headers: headers,
              body: formData
            });

          case 54:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 39, 43, 53], [44,, 48, 52]]);
  }));
  return _multipartRequest.apply(this, arguments);
}

exports.multipartRequest = multipartRequest;